<script lang="ts">
	import Button from "#lib/ui/Button/index.js";
	import type { ButtonProps } from "flowbite-svelte/Button.svelte";

	type $$Props = ButtonProps;
</script>

<!-- eslint-disable-next-line custom/no-button-without-data-action-name -->
<Button {...$$props} color="light" class="border-0 p-2! ring-0!" size="sm" on:click>
	<slot />
</Button>
